import React, { useCallback } from 'react';
import { Card, CardBody } from 'reactstrap';

import { useNotify } from 'js/hooks/useNotify';
import { OrgWeightsProvider, useOrgWeights } from './OrgWeightsContext';
import OrgWeightSchemePicker from './OrgWeightSchemePicker';
import OrgCustomWeights from './OrgCustomWeights';
import styles from './OrgWeights.module.scss';

function OrgWeightsEditor({ organization }) {
  const { config, saving, isCustomScheme, onSchemeChange } = useOrgWeights();

  return (
    <div className="manage-org">
      <Card>
        <CardBody>
          <OrgWeightSchemePicker
            scheme={config.scheme}
            onSchemeChange={onSchemeChange}
            disabled={saving}
          />

          <OrgCustomWeights
            organization={organization}
            readOnly={!isCustomScheme}
          />

          {saving && (
            <p className={`text-muted small mb-0 ${styles['save-status']}`}>
              Saving…
            </p>
          )}
        </CardBody>
      </Card>
    </div>
  );
}

function OrgWeights({ organization, orgSyncKey, onPersist }) {
  const notify = useNotify();

  const persistWithNotify = useCallback(
    async (orgId, payload) => {
      try {
        await onPersist(orgId, payload);
      } catch (err) {
        const message =
          err?.response?.data?.message ??
          err?.response?.data?.errors?.[0]?.detail ??
          err?.message ??
          'Unable to save organization weights.';
        notify({ type: 'danger', message });
        throw err;
      }
    },
    [onPersist, notify]
  );

  if (!organization?.id) {
    return null;
  }

  return (
    <OrgWeightsProvider
      organization={organization}
      orgSyncKey={orgSyncKey}
      onPersist={persistWithNotify}
    >
      <OrgWeightsEditor organization={organization} />
    </OrgWeightsProvider>
  );
}

export default OrgWeights;
